export class ActionSelectedModifiers1 {
  static readonly type = "[MODIFIERS] SET MODIFIERS";
  constructor(public payload: any) {}
}
